import { ModelType, TireSize, ProviderLocation } from 'app/profile/models/loaner-wheel-inventory';

export interface LoanerWheelInventoryState {
    modelTypes: ModelType[];
    tireSize: TireSize[];
    providerLocation: ProviderLocation[];
}

export const initialState: LoanerWheelInventoryState = {
    modelTypes: null,
    tireSize: null,
    providerLocation: null,
};
